import { render, staticRenderFns } from "./GiardinoSlideshow.vue?vue&type=template&id=67a7d550&"
import script from "./GiardinoSlideshow.vue?vue&type=script&lang=js&"
export * from "./GiardinoSlideshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports